import React from "react";

function Footer() {
    return (
        <>
            <div className="">
                <div className="row bg-blue mx-0" style={{ padding: "3% 5% 3% 15%" }}>
                    <div className="col-4" style={{ lineHeight: "2rem" }}>
                        <a target="_blank" href="https://www.raininfotech.in/hyperledger-development-company/" className="text-light">
                            Hyperledger Development
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/nft-marketplace-development-company/" className="text-light">
                            NFT Marketplace Development
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/smart-contract-development/" className="text-light">
                            Smart Contract Development
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/decentralized-exchange-development-company/" className="text-light">
                            Decentralized Exchange Development
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/dapp-development-company/" className="text-light">
                            dApp Development
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/hybrid-coin-development/" className="text-light">
                            EVM Based Blockchain
                        </a>
                        <br />
                    </div>
                    <div className="col-4" style={{ lineHeight: "2rem" }}>
                        <a target="_blank" href="https://www.raininfotech.in/deFi-lottery/" className="text-light">
                            DeFi Development
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/ico-development/" className="text-light">
                            ICO Development
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/masternode-coin-development/" className="text-light">
                            Masternode Coin Development
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/web-3-0-development-company/" className="text-light">
                            Web 3.O Development
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/block-explorer/" className="text-light">
                            Block Explorer
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/flutter-development-company/" className="text-light">
                            Flutter App Development
                        </a>
                        <br />
                    </div>
                    <div className="col-4" style={{ lineHeight: "2rem" }}>
                        <a target="_blank" href="https://www.raininfotech.in/nextjs-development-company/" className="text-light">
                            NextJS Development
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/mern-stack-development-company/" className="text-light">
                            MERN Stack Development
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/about-rain-infotech/" className="text-light">
                            About Us
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/portfolio/" className="text-light">
                            Potfolio
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/contact-us/" className="text-light">
                            Contact Us
                        </a>
                        <br />
                        <a target="_blank" href="https://www.raininfotech.in/life-at-rain-infotech/" className="text-light">
                            Life at Rain Infotech
                        </a>
                        <br />
                    </div>
                </div>
                <div className="row bg-light py-3 mx-0">
                    <div className="col-6">
                        <a target="_blank" href="https://www.raininfotech.in" className="text-light">
                            <img src="/rain_logo.svg"></img>
                        </a>
                    </div>
                    <div className="col-6 d-flex justify-content-end place-items-center mt-2">
                        <a target="_blank" href="https://www.facebook.com/RainInfotech">
                            <img src="/images/facebook.svg" className="h-75 mx-1"></img>
                        </a>
                        <a target="_blank" href="https://twitter.com/raininfotech">
                            <img src="/images/twitter.svg" className="h-75 mx-1"></img>
                        </a>
                        <a target="_blank" href="https://instagram.com/raininfotechprivatelimited">
                            <img src="/images/instagram.svg" className="h-75 mx-1"></img>
                        </a>
                        <a target="_blank" href="https://www.youtube.com/channel/UCCm_vX18gT_3EDlHcGDKyTA">
                            <img src="/images/youtube.svg" className="h-75 mx-1"></img>
                        </a>
                        <a target="_blank" href="https://github.com/raininfotech">
                            <img src="/images/github.svg" className="h-75 mx-1"></img>
                        </a>
                        <a
                            target="_blank"
                            href="https://www.linkedin.com/authwall?trk=qf&original_referer=https://www.raininfotech.in/life-at-rain-infotech/&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Frain-infotech"
                        >
                            <img src="/images/linkedin.svg" className="h-75 mx-1"></img>
                        </a>
                        <a target="_blank" href="skype:rain.infotech?chat">
                            <img src="/images/skype.svg" className="h-75 mx-1"></img>
                        </a>
                        <a target="_blank" href="https://api.whatsapp.com/send?l=en&phone=919586966688">
                            <img src="/images/whatsapp.svg" className="h-75 mx-1"></img>
                        </a>
                        <a target="_blank" href="https://t.me/raininfotech">
                            <img src="/images/telegram.svg" className="h-75 mx-1"></img>
                        </a>
                        <a target="_blank" href="https://www.shutterstock.com/g/RainInfotech">
                            <img src="/images/shutterstock.svg" className="h-75 mx-1"></img>
                        </a>
                        <a target="_blank" href="https://in.pinterest.com/raininfotech/">
                            <img src="/images/pinterest.svg" className="h-75 mx-1"></img>
                        </a>
                        <a target="_blank" href="https://dribbble.com/raininfotech">
                            <img src="/images/dribble.svg" className="h-75 mx-1"></img>
                        </a>
                        <a target="_blank" href="https://www.behance.net/raininfotech">
                            <img src="/images/behance.svg" className="h-75 mx-1"></img>
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Footer;
